import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestGET} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import {clearResource, setResource} from "../redux/actions";
import downloadFileWithPreloadUrl from "../libs/downloadFileWithPreloadUrl";


const GENERAL_INFO_BASIC_DATA = "generalInfoBasicData";
const GENERAL_INFO_DOCUMENTS = "generalInfoDocuments";
const GENERAL_INFO_PUBLIC_ANSWERS = "generalInfoPublicAnswers";


const getContractorGeneralInfoBasicData = async (demandId, stageId, supplierId) => {
    const params = {supplierId}
    const resp = await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_BASIC_DATA(demandId, stageId, supplierId),{params});
    reduxStore.dispatch(setResource(GENERAL_INFO_BASIC_DATA, resp));
}
const getContractorGeneralInfoDocuments = async (demandId, stageId, supplierId) => {
    const params = {supplierId}
    const resp = await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_DOCUMENTS(demandId, stageId, supplierId), {params});
    reduxStore.dispatch(setResource(GENERAL_INFO_DOCUMENTS, resp));
}
const getContractorGeneralInfoPublicAnswers = async (demandId, stageId, supplierId) => {
    const params = {supplierId}
    const resp = await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_PUBLIC_ANSWERS(demandId, stageId, supplierId), {params});
    reduxStore.dispatch(setResource(GENERAL_INFO_PUBLIC_ANSWERS, resp));
}
const getDownloadFile = async (demandId, stageId, type, documentId, supplierId) => {
    const params = {supplierId}
    await downloadFileWithPreloadUrl(
        Endpoints.DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_DOCUMENTS_DOWNLOAD_URL(demandId, stageId, type, documentId, supplierId),
        false, params);
}
const downloadContractorGeneralInfoDocumentsZip = async (demandId, stageId, supplierId, finallyCallback = () => {
}) => {
    const params = {supplierId}
    RestRequestBLOB(Endpoints.DEMAND_OFFERS_CONTRACTOR_GENERAL_INFO_DOCUMENTS_DOWNLOAD_ZIP(demandId, stageId, supplierId), {params})
        .finally(finallyCallback);
}
const clearResources = (resId) => reduxStore.dispatch(clearResource(resId));

export default {
    getContractorGeneralInfoBasicData,
    getContractorGeneralInfoDocuments,
    getContractorGeneralInfoPublicAnswers,
    getDownloadFile,
    downloadContractorGeneralInfoDocumentsZip,
    clearResources,
    GENERAL_INFO_BASIC_DATA,
    GENERAL_INFO_DOCUMENTS,
    GENERAL_INFO_PUBLIC_ANSWERS
}